const TUTORIAL_COMPLETED_KEY = 'neo-modelos:tutorial-completed:v2';

export function isTutorialCompleted() {
  try {
    return window.localStorage.getItem(TUTORIAL_COMPLETED_KEY) === 'true';
  } catch {
    return false;
  }
}

export function markTutorialCompleted() {
  try {
    window.localStorage.setItem(TUTORIAL_COMPLETED_KEY, 'true');
  } catch {
    // ignore quota / private mode errors
  }
}

export { TUTORIAL_COMPLETED_KEY };
